import React, { useState, useMemo, useEffect } from "react";
import jwt from "jsonwebtoken";
import { httpPost, httpGet } from "./fetcher";
export var AuthContext = React.createContext(null);
var AUTH_TOKEN = "STREAMY_AUTH_TOKEN";
var REFRESH_TOKEN = "STREAMY_REFRESH_TOKEN";
var AuthContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), tokenData = _b[0], setTokenData = _b[1];
    var _c = useState(), user = _c[0], updateUser = _c[1];
    var _d = useState("idle"), userFetchStatus = _d[0], setUserFetchStatus = _d[1];
    var _e = useState(), accessToken = _e[0], setAccessToken = _e[1];
    var logout = function (message) {
        setTokenData(undefined);
        updateUser(undefined);
        window.sessionStorage.removeItem(AUTH_TOKEN);
        window.localStorage.removeItem(REFRESH_TOKEN);
        var s = new URLSearchParams();
        if (message) {
            s.append("a", "logout");
            s.append("t", message.type);
            s.append("msg", message.text);
        }
        window.location.href = "/?" + s.toString();
    };
    var fetchUser = function () {
        if (!user) {
            setUserFetchStatus("pending");
            httpGet("users/me")
                .then(function (d) {
                updateUser(d);
                setUserFetchStatus("resolved");
            })
                .catch(function (e) {
                setUserFetchStatus("rejected");
            });
        }
    };
    var login = function (accessToken, refreshToken, user) {
        window.sessionStorage.setItem(AUTH_TOKEN, accessToken);
        window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
        setAccessToken(accessToken);
        var token = jwt.decode(accessToken);
        setTokenData(token);
        if (user) {
            updateUser(user);
        }
        else {
            setUserFetchStatus("pending");
            httpGet("users/me")
                .then(function (d) {
                updateUser(d);
                setUserFetchStatus("resolved");
            })
                .catch(function (e) {
                setUserFetchStatus("rejected");
            });
        }
        if (window.$crisp) {
            window.$crisp.push(["set", "user:email", [token.user.email]]);
        }
    };
    var isLoggedin = useMemo(function () { return (tokenData && tokenData.exp > Date.now() / 1000) || false; }, [tokenData]);
    useEffect(function () {
        if (tokenData && !isLoggedin) {
            logout();
        }
    }, [tokenData, isLoggedin]);
    // check for tokens on startup
    useEffect(function () {
        var accessTokenStr = window.sessionStorage.getItem(AUTH_TOKEN);
        var refreshToken = window.localStorage.getItem(REFRESH_TOKEN);
        if (accessTokenStr) {
            var accessToken_1 = jwt.decode(accessTokenStr);
            // try to refresh token if it is expired or will expire within 5 minutes
            if (accessToken_1.exp < Date.now() / 1000 - 300 || !refreshToken) {
                setUserFetchStatus("pending");
                httpPost("auth/refresh", JSON.stringify({
                    refreshToken: refreshToken,
                }))
                    .then(function (d) {
                    setUserFetchStatus("resolved");
                    login(d.accessToken, d.refreshToken, d.user);
                })
                    .catch(function (e) {
                    setUserFetchStatus("rejected");
                    logout();
                });
            }
            if (accessToken_1) {
                login(accessTokenStr, refreshToken);
            }
        }
        else if (refreshToken) {
            setUserFetchStatus("pending");
            httpPost("auth/refresh", JSON.stringify({
                refreshToken: refreshToken,
            }))
                .then(function (d) {
                setUserFetchStatus("resolved");
                login(d.accessToken, d.refreshToken, d.user);
            })
                .catch(function (e) {
                setUserFetchStatus("rejected");
                logout();
            });
        }
    }, []);
    var context = {
        accessToken: accessToken,
        isLoggedin: isLoggedin,
        login: login,
        logout: logout,
        tokenData: tokenData,
        updateUser: updateUser,
        user: user,
        userFetchStatus: userFetchStatus,
        fetchUser: fetchUser,
    };
    return React.createElement(AuthContext.Provider, { value: context }, children);
};
export { AuthContextProvider };
//# sourceMappingURL=auth.js.map